exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".statistic-title[data-v-15a90a62]{font-weight:700}.empty-list[data-v-15a90a62]{text-align:center}", ""]);

// exports
